export default __webpack_public_path__ + "static/media/plain-sticker-V.25558d05.png";